export const storageKeys = {
  ROUTE_DATA_KEY: "routeDataKey",
  CX_DB_FILTERS: "cxDatabaseFilters",
  ACTIVE_TICKET_STATE: "activeTicketState",
  USER_PROFILE_KEY: "userProfile",
  USER_ROLE_KEY: "userRoleInfo",
  USER_DETAILS_KEY: "userDetails",
  ROLE_DATA_KEY: "roleDetailsData",
  SESSION_TOKEN: "sessionToken",
  LS_USER_DETAILS: "userDetails",
  JOB_DB_FILTERS: "jobDatabseFilters",
  TICKET_REVIEW_REFRESH: "wereAllTicketsMoved",
  JOB_DB_PAGE: "jobDatabasePage",
  JOB_DB_PAGESIZE: "jobDatabasePageSize",
  QUARRY_DB_FILTERS: "quarryDatabaseFilters",
  CUSTOMER_DB_PAGE: "customerDatabasePage",
  CUSTOMER_DB_PAGESIZE: "customerDatabasePageSize",
  QUARRY_DB_PAGE: "quarryDatabasePage",
  QUARRY_DB_PAGESIZE: "quarryDatabasePageSize",
  TICKET_UPLOAD_PAGESIZE: "ticketUploadPageSize",
  TICKET_PROCESSING_PAGESIZE: "ticketProcessingPageSize",
  INVOICE_LIST_PAGESIZE: "invoiceListPageSize",
  INVOICE_TILE_PAGESIZE: "invoiceTilePageSize",
  LIEN_PAGESIZE: "lienPageSize",
  CRM_PAGESIZE: "crmPageSize",
  RESTORE_CUSTOMER_PAGESIZE: "customerRestorePageSize",
  RESTORE_QUARRY_PAGESIZE: "quarryRestorePageSize",
  RESTORE_OWNER_PAGESIZE: "ownerOperatorRestorePageSize",
  RESTORE_CDL_PAGESIZE: "cdlRestorePageSize",
  RESTORE_JOB_PAGESIZE: "jobRestorePageSize",
  RESTORE_CUSTOMER_DEP_PAGESIZE: "customerDependentRestorePageSize",
  RESTORE_QUARRY_DEP_PAGESIZE: "quarryDependentRestorePageSize",
  RESTORE_OWNER_DEP_PAGESIZE: "ownerOperatorDependentRestorePageSize",
  RESTORE_JOB_DEP_PAGESIZE: "jobDependentRestorePageSize",
  CRM_SHOW_BLOCKED: "crmShowBlocked",
  JOB_DB_AFFECTED_ORDERS_PAGE: "jobDBAffectedOrdersPage",
  JOB_DB_AFFECTED_ORDERS_PAGESIZE: "jobDBAffectedOrdersPageSize"
};
